import { useState } from "react";
import {
  Form,
  Button,
  Container,
  Row,
  Col,
  Alert,
  Image,
  Spinner,
} from "react-bootstrap";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "../styles/icon.css";

const Login = () => {
  const [formData, setFormData] = useState({ username: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!formData.username || !formData.password) {
      setError("Please fill in both fields.");
      return;
    }

    const API_BASE = process.env.REACT_APP_API_BASE_URL;
    setLoading(true);

    try {
      const response = await axios.post(
        `${API_BASE}/api/customers/login`,
        formData
      );

      localStorage.setItem("token", response.data.token);
      localStorage.setItem("customer_id", response.data.customer_id);
      localStorage.setItem("username", response.data.username);

      navigate("/customer");
    } catch (error) {
      if (error.response) {
        setError(error.response.data.message || "Invalid login credentials.");
      } else if (error.request) {
        setError("No response from server. Please try again.");
      } else {
        setError("An unexpected error occurred.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="login-container mt-5">
      <Row className="justify-content-center">
        <Col md={6} className="text-center">
          <Image
            src="/images/login.png"
            alt="Login"
            fluid
            className="login-icon"
          />
        </Col>
      </Row>

      <Row className="justify-content-center">
        <Col md={6}>
          <h2 className="text-center mb-4">Customer Login</h2>

          {error && <Alert variant="danger">{error}</Alert>}

          <Form onSubmit={handleSubmit}>
            {/* Username */}
            <Form.Group as={Row} className="mb-3" controlId="username">
              <Form.Label column sm={4}>
                Username
              </Form.Label>
              <Col sm={8}>
                <Form.Control
                  type="text"
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  placeholder="Enter your Username"
                  required
                />
              </Col>
            </Form.Group>

            {/* Password + Toggle */}
            <Form.Group as={Row} className="mb-3" controlId="password">
              <Form.Label column sm={4}>
                Password
              </Form.Label>
              <Col sm={8} className="d-flex align-items-center">
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Enter your password"
                  required
                />
                <Button
                  variant="outline-secondary"
                  onClick={togglePasswordVisibility}
                  type="button"
                  className="ms-2 px-2 py-1"
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </Button>
              </Col>
            </Form.Group>

            {/* Submit Button */}
            <Form.Group as={Row} className="mb-3">
              <Col sm={{ span: 8, offset: 4 }}>
                <Button
                  variant="primary"
                  type="submit"
                  className="w-100"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <Spinner
                        animation="border"
                        size="sm"
                        role="status"
                        className="me-2"
                      />
                      Logging in...
                    </>
                  ) : (
                    "Login"
                  )}
                </Button>
              </Col>
            </Form.Group>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;
